import React from "react";
import { Modal, Typography, Button, Stack, IconButton } from "@mui/material";
import { observer } from "mobx-react";
import { useStores } from "../../hooks/useStores";
import Image from "../image";
import Iconify from "../iconify";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ClimberReport from "@/components/certificate-pdf";
import { useCurrentUser } from "@/hooks/useCurrentUser";

const CertificateAwardDialog = observer(() => {
  const { sessionStore } = useStores();
  const currentUser = useCurrentUser();
  const { newlyCompletedAwards, careerClimbCompletionData } = sessionStore;

  const handleSurveyClick = (surveyUrl) => {
    if (surveyUrl) window.open(surveyUrl, "_blank");
  };

  // const award = {
  //   awardRule: "all_climbs_in_plan",
  //   awardType: "certificate",
  //   awardDescription:
  //     "This certificate is awarded to Community OY participants who have completed the self-guided orientation for SYEP 2025.",
  //   image: {
  //     url: "https://hats-content.hatsandladders.com/SYEP 2025 Community certificate badge.svg",
  //     alt: "SYEP 2025 Community certificate badge",
  //   },
  //   completionMessage:
  //     '[{"children":[{"text":"This certificate is awarded to Community YY participants who have completed the self-guided orientation for SYEP 2025. "}]}]',
  //   id: "3",
  //   name: "SYEP OY Community",
  //   productPlan: [
  //     {
  //       code: "syep-oy-cy",
  //     },
  //   ],
  //   requiredClimbs: [],
  //   requiredPlan: "syep-oy-cy",
  //   title: "OY Orientation SYEP 2025",
  // }; // for testing

  if (careerClimbCompletionData) {
    // Don't want to display the award and career climb at the same time.
    return null;
  }

  if (newlyCompletedAwards.length === 0) {
    return null;
  }

  const award = newlyCompletedAwards[0]; // Show one award at a time
  const rawMetadata = award.certificateConfig?.metadata;
  const metadata =
    typeof rawMetadata === "string"
      ? (() => {
          try {
            return JSON.parse(rawMetadata);
          } catch {
            return {};
          }
        })()
      : rawMetadata || {};
  const surveyUrl = metadata.surveyUrl;

  const handleClose = () => {
    sessionStore.removeFirstCompletedAward();
  };

  const formatedCompletionRecord = new Date().toLocaleDateString("en-US", {
    // award.completedAt,
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });
  return (
    <Modal
      open={true}
      onClose={handleClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        "&:focus-visible": { outline: "none" },
      }}
    >
      <Stack
        sx={{
          margin: "25px",
          padding: "24px 12px",
          backgroundColor: "#fff",
          width: "95%",
          maxWidth: "600px",
        }}
      >
        <Stack
          direction="row"
          sx={{
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <IconButton onClick={handleClose}>
            <Iconify sx={{ width: "20px", height: "20px" }} icon="mdi:close" />
          </IconButton>
        </Stack>

        <Stack
          direction="column"
          alignItems="center"
          sx={{
            padding: "12px 24px",
          }}
        >
          <Typography
            variant="h2"
            sx={{ fontFamily: "Nunito", fontWeight: 600, pb: 3 }}
          >
            Congratulations!
          </Typography>

          <Typography variant="h4" sx={{ mb: 4, textAlign: "center" }}>
            You&apos;ve just earned a new certificate for
            <br />
            {award.title}!
          </Typography>

          {award.image && (
            <Image
              alt={award.image.alt}
              src={award.image.url}
              sx={{
                w: "240px",
                height: "240px",
                mb: 3,
              }}
            />
          )}
          <Button sx={{ mb: 0, p: 0 }}>
            <PDFDownloadLink
              document={
                <ClimberReport
                  award={award}
                  completionDate={formatedCompletionRecord}
                  currentUser={currentUser}
                />
              }
              fileName="Hats_and_Ladders_Certificate.pdf"
              style={{
                textDecoration: "underline",
                color: "#1C252E",
                fontFamily: "ProximaNova Bold",
                fontSize: "16px",
                mb: 0,
              }}
            >
              {({ loading }) =>
                loading ? "Generating PDF..." : "Download Certificate"
              }
            </PDFDownloadLink>
          </Button>
          <Typography
            variant="body1"
            sx={{
              mb: 3,
              textAlign: "center",
              color: "text.secondary",
              mt: "0 !important",
            }}
          >
            You can access certificates at any time from your Achievements.
          </Typography>

          <Stack
            sx={{
              width: "420px",
              maxWidth: "100%",
              p: 3,
              backgroundColor: "rgba(7, 141, 238, 0.08)",
              borderRadius: 1,
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontFamily: "ProximaNova Bold",
                pb: 1,
              }}
            >
              Please take a few minutes to tell us what you think.
            </Typography>
            <Button
              variant="contained"
              color="primary"
              sx={{
                alignSelf: "center",
                width: "234px",
              }}
              onClick={() => handleSurveyClick(surveyUrl)}
            >
              Take Survey
            </Button>
          </Stack>
          {/* 
          {award.completionMessage && (
            <Typography variant="subtitle1" sx={{ mb: 4, fontWeight: 500 }}>
              <RichText value={award.completionMessage} />
            </Typography>
          )} */}
        </Stack>
      </Stack>
    </Modal>
  );
});

export default CertificateAwardDialog;
